
import { Row, Col, Card, Button, Image } from 'react-bootstrap'
import { useSelector } from "react-redux"
import { useState } from "react"

import navIcon2 from "../../assets/img/nav-icon2.svg";
import youTube from '../../assets/svg/brand-logos/icons8-youtube-logo-100.svg';

import EditModal from './modals/EditMeeting'

export default function MeetingCard({ meeting, getMeeting, assignments }) {

  // const url = process.env.REACT_APP_URL;

  const noBgImage = process.env.REACT_APP_NO_BG_IMAGE

  // console.log('assignments', assignments)

  const { user: authUser } = useSelector(x => x.auth)

  const backgroundImage = (meeting.meetingDetails?.imageUrl === '' || meeting.meetingDetails?.imageUrl === 'undefined' || !meeting.meetingDetails?.imageUrl) ? noBgImage : meeting.meetingDetails.imageUrl

  const [isCollapsed, setIsCollapsed] = useState(false)

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  const toastmaster = assignments?.find(
    (assignment) => assignment.role?.name === "Toastmaster"
  )?.user;

  // console.log('toastmaster', toastmaster)

  return (
    <section>
      <Row className='mt-3 mb-3'>
        <Col>
          <Card className='my-2 text-center semi-transparent text-white bg-dark bigCard' >
            <Card.Header onClick={toggleCollapse}>
              <Row className="header mb-2" style={{ cursor: 'pointer', paddingTop: '5px' }}>
                <Col xs={11} lg={11} className="title">
                  <h5>{(meeting.meetingDetails?.meetingNumber !== null) && '#' + meeting.meetingDetails?.meetingNumber} &nbsp;
                    {meeting.meetingDetails?.meetingTheme}</h5>
                </Col>
                <Col xs={1} lg={1}>
                  <i
                    className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}
                  ></i>
                </Col>
              </Row>
            </Card.Header>

            {!isCollapsed && (
              <>
                <Card.Body className='to-left'>
                  <Row className='bigCard'>
                    <Col xs={12} lg={12} >
                      <Card.Img variant="top" src={backgroundImage} alt="Meeting Background" />
                      {(!meeting.meetingDetails?.imageUrl || meeting.meetingDetails?.imageUrl === '' || meeting.meetingDetails?.imageUrl === 'undefined') &&
                        <>
                          {!toastmaster?.avatar
                            ? '' :
                            <Row>
                              <Col className='hexagon'>
                                <Image src={'data:image/png;base64,' + toastmaster?.avatar} />
                              </Col>
                            </Row>
                          }
                          <h3 className='not-found-title'>{meeting.meetingDetails?.meetingTheme}</h3>
                        </>
                      }
                    </Col>
                  </Row>
                  <Row >
                    <Col className='mt-1'>
                      <h3 className='mb-1'>{meeting.meetingDetails?.meetingTheme}</h3>
                      <p className='text-center'>{meeting.meetingDetails?.meetingType} Meeting <span>{(meeting.meetingDetails?.meetingNumber !== null) && '#' + meeting.meetingDetails?.meetingNumber}</span></p>
                      <p className='text-center'>{meeting.meetingDetails?.meetingDate}</p>
                      <h6>{meeting.meetingDetails?.meetingDescription !== '' && <>{meeting.meetingDetails?.meetingDescription}</>} </h6>
                      <br />
                    </Col>
                  </Row>
                  <Row className='to-left'>
                    <Col className='social-icon mt-3'>
                      {(meeting.meetingDescription?.facebookUrl !== '' && meeting.meetingDescription?.facebookUrl) ? <a href={meeting.meetingDetails?.facebookUrl} target='_blank' rel="noreferrer"><img src={navIcon2} alt="Facebook Icon Event" /></a> : ''}
                      {(meeting.meetingDescription?.youtubeUrl !== '' && meeting.meetingDescription?.youtubeUrl) ? <a href={meeting.meetingDetails?.youtubeUrl} target='_blank' rel="noreferrer"><img src={youTube} alt="Youtube Icon Event" /></a> : ''}
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer>
                  <Row>
                    <Col xs={6} lg={6} className='text-start'>
                      {(authUser && authUser.user.acl === 'Officer') &&
                        <EditModal meeting={meeting} getMeeting={getMeeting} />
                      }
                    </Col>
                    <Col xs={6} lg={6} className='float-end'>
                      <Button variant='dark' className='float-end' onClick={getMeeting}>
                        <i className='bi bi-arrow-clockwise'></i> Reload Meeting Info
                      </Button>
                    </Col>
                  </Row>
                </Card.Footer>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </section >
  )
}